import styled, { css, keyframes } from 'styled-components';

const fadeOut = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(0.97);
    opacity: 0.5;
  }
`;

export const Container = styled.div`
  display: grid;
  place-items: center;

  & > p {
    line-height: 20px;
  }
`;

export const Content = styled.div`
  background-color: #fff;
  padding: 0.2em;
  margin: 1em;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
  border-radius: 0.6em;
`;

export const ConteinerDescription = styled.div`
  padding: 1em;
`;

export const Description = styled.p`
  color: #617385;
`;

export const ConteinerButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
  margin: 0.5em 0;

  @media (max-width: 768px) {
  }
  @media (max-width: 425px) {
  }

  @media (max-width: 320px) {
    button {
      padding: 0 1em;
    }
  }
`;

export const ConteinerTextArea = styled.div`
  margin: 0 auto;
  padding: 1em;

  @media (max-width: 768px) {
  }
  @media (max-width: 425px) {
  }

  @media (max-width: 320px) {
  }
`;

export const Wrapper = styled.div`
  padding: 1em 0;
  width: 100%;

  @media (max-width: 768px) {
    width: auto;
  }
  @media (max-width: 425px) {
  }
  @media (max-width: 320px) {
  }
`;

export const ContentTextarea = styled.div`
  position: relative;
  width: 100%;
`;

export const ContentPergunta = styled.div`
  display: flex;

  margin: 0 0 1em 0;

  @media (max-width: 768px) {
  }
  @media (max-width: 425px) {
  }

  @media (max-width: 320px) {
  }
`;

export const Title = styled.p`
  color: #000;
  font-size: 1em;

  @media (max-width: 768px) {
  }
  @media (max-width: 425px) {
    font-size: 12px;
  }
  @media (max-width: 320px) {
  }
`;
export const SubTitle = styled.p`
  font-weight: normal;
  color: #8f8f8f;
  font-size: 13px;
  margin-top: 8px;

  @media (max-width: 768px) {
  }
  @media (max-width: 425px) {
    font-size: 11px;
  }
  @media (max-width: 320px) {
  }
`;

export const Microphone = styled.div`
  background-image: url('https://base-estatico.sebrae.com.br/images/icons/microphone.svg');
  /* filter: invert(28%) sepia(7%) saturate(2258%) hue-rotate(168deg)
    brightness(95%) contrast(90%); */
  cursor: pointer;
  height: 22px;
  width: 22px;
  top: 20px;
  right: 18px;

  ${({ recording }) =>
    recording &&
    css`
      animation: ${fadeOut} 600ms alternate infinite;
      filter: invert(16%) sepia(86%) saturate(3076%) hue-rotate(13deg)
        brightness(97%) contrast(108%);

      &:hover {
        background-image: url('https://base-estatico.sebrae.com.br/images/icons/microphone-slash.svg');
      }
    `}
`;

export const InfoHeader = styled.div`
  display: flex;
  gap: 10px;
`;

export const InfoBody = styled.div`
  padding-top: 5px;
  padding-left: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ContentSaving = styled.div`
  position: absolute;
  top: -19px;
  right: 10px;
`;

export const ContentMic = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 99999;
`;

export const TabsWrapper = styled.div`
  display: grid;
  place-items: center;
  .BaSe--tabs
    ul
    li.BaSe--tab:nth-child(${(props) => props.activeIndex + 1})
    button
    h5 {
    color: ${(props) => props.activeColor} !important;
     font-family: 'Inter', sans-serif;
     font-size: 0.9em;
  }

  .BaSe--tabs
    ul
    li.BaSe--tab:nth-child(${(props) => props.activeIndex + 1})
    button
    img {
    filter: ${(props) => props.activeFilter} !important;
  }

  ${(props) =>
    props.completedIndexes
      .map(
        (index) => `
    .BaSe--tabs ul li.BaSe--tab:nth-child(${index + 1}) button h5 {
      color: #008437 !important;
      font-family: 'Inter', sans-serif;
      font-size: 0.9em;

    }
    .BaSe--tabs ul li.BaSe--tab:nth-child(${index + 1}) button img {
      filter: invert(27%) sepia(92%) saturate(1016%) hue-rotate(119deg) brightness(97%) contrast(101%) !important;
    }
  `,
      )
      .join('')}
`;
